<template>
  <section id="donor-profile-section" class="section-scc-portal container">
    <div id="container-page-title" style="display: flex">
      <h1>User Information</h1>
    </div>
    <form class="form-box-shadow" id="form-my-profile-portal-scc">
      <div class="row">
        <div class="left-col col-md-6">
          <div class="row container-item-form">
            <div class="container-input-form container-input-form-left col-sm">
              <label class="label-form-css col-sm-auto" style="padding-left: 0;">Email:</label>
              <div class="row container-item-form" style="align-items: baseline; margin-top: 0;">
                <input
                    type="email"
                    class="form-control input-form-css col-sm"
                    id="email-my-profile"
                    :disabled="disabledInputs.disabledEmail"
                    v-model="donorInformation.email"
                >
                <button
                    type="button"
                    v-if="changeDonorInformation.changeEmail"
                    class="col-sm-auto btn"
                    @click="disabledInputs.disabledEmail = !disabledInputs.disabledEmail"
                >
                  <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
                </button>
              </div>
            </div>
            <div id="out-container-reset-password-button"
                 class="container-input-form container-input-form-reset container-input-form-right col-sm">
              <div class="row container-item-form container-item-form-button container-item-form-button-reset"
                   style="text-align:center; width:auto">
                <button
                    type="button"
                    class="button-section btn button-reset"
                    id="reset_password_my_profile"
                    @click="resetPassword"
                >
                  RESET PASSWORD

                  <font-awesome-icon :icon="['fas', 'chevron-right']"/>
                </button>
              </div>
            </div>
          </div>
          <div class="row container-item-form">
            <div class="container-input-form container-input-form-left col-sm">
              <label class="label-form-css col-sm-auto" style="padding-left: 0;">First Name:</label>
              <div class="row container-item-form" style="align-items: baseline; margin-top: 0;">
                <input
                    type="text"
                    class="form-control input-form-css col-sm"
                    id="first-name-my-profile"
                    :disabled="disabledInputs.disabledFirstName"
                    v-model="donorInformation.firstName"
                >
                <button
                    type="button"
                    v-if="changeDonorInformation.changeFirstName"
                    class="col-sm-auto btn"
                    @click="disabledInputs.disabledFirstName = !disabledInputs.disabledFirstName"
                >
                  <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
                </button>
              </div>
            </div>
            <div class="container-input-form container-input-form-right col-sm">
              <label class="label-form-css col-sm-auto" style="padding-left: 0;">Last Name:</label>
              <div class="row container-item-form" style="align-items: baseline; margin-top: 0;">
                <input
                    type="text"
                    class="form-control input-form-css col-sm"
                    id="last-name-my-profile"
                    :disabled="disabledInputs.disabledLastName"
                    v-model="donorInformation.lastName"
                >
                <button
                    type="button"
                    v-if="changeDonorInformation.changeLastName"
                    class="col-sm-auto btn"
                    @click="disabledInputs.disabledLastName = !disabledInputs.disabledLastName"
                >
                  <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
                </button>
              </div>
            </div>
          </div>
          <div class="row container-item-form">
            <div class="container-input-form container-input-form-left col-sm">
              <label class="label-form-css" for="date-birth-my-profile">Date of Birth</label>
              <input
                  type="text"
                  class="form-control input-form-css"
                  id="date-birth-my-profile"
                  v-model="donorInformation.dob"
                  disabled="disabled"
              >
            </div>
            <div class="container-input-form container-input-form-right col-sm">

            </div>
          </div>
          <div class="row container-item-form">
            <div class="container-input-form container-input-form-left col-sm">
              <label class="label-form-css col-sm-auto" style="padding-left: 0;">Cell #:</label>
              <div class="row container-item-form" style="align-items: baseline; margin-top: 0;">
                <input
                    type="tel"
                    class="form-control input-form-css col-sm"
                    id="mobile-phone-my-profile"
                    :disabled="disabledInputs.disabledMobilePhone"
                    v-model="donorInformation.mobilePhone"
                >
                <button
                    type="button"
                    v-if="changeDonorInformation.changeMobilePhone"
                    class="fa fa-pencil-alt col-sm-auto btn"
                    @click="disabledInputs.disabledMobilePhone = !disabledInputs.disabledMobilePhone"
                >
                  <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
                </button>

              </div>
            </div>
            <div class="container-input-form container-input-form-right col-sm">
              <label class="label-form-css col-sm-auto" style="padding-left: 0;">Home Phone:</label>
              <div class="row container-item-form" style="align-items: baseline; margin-top: 0;">
                <input
                    type="tel"
                    class="form-control input-form-css col-sm"
                    id="home-phone-my-profile"
                    :disabled="disabledInputs.disabledHomePhone"
                    v-model="donorInformation.homePhone"
                >
                <button
                    type="button"
                    v-if="changeDonorInformation.changeHomePhone"
                    class="col-sm-auto btn"
                    @click="disabledInputs.disabledHomePhone = !disabledInputs.disabledHomePhone"
                >
                  <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
                </button>
              </div>
            </div>
          </div>
          <div class="row container-item-form">
            <div class="container-input-form container-input-form-left col-sm">
              <label class="label-form-css col-sm-auto" style="padding-left: 0;">Street:</label>
              <div class="row container-item-form" style="align-items: baseline;">
                <input
                    type="text"
                    class="form-control input-form-css col-sm"
                    id="street-my-profile"
                    :disabled="disabledInputs.disabledStreet"
                    v-model="donorInformation.street"
                >
                <button
                    type="button"
                    v-if="changeDonorInformation.changeStreet"
                    class="col-sm-auto btn"
                    @click="disabledInputs.disabledStreet = !disabledInputs.disabledStreet"
                >
                  <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
                </button>
              </div>
            </div>
          </div>
          <div class="row container-item-form">
            <div class="container-input-form container-input-form-left col-sm-5">
              <label class="label-form-css col-sm-auto" style="padding-left: 0;">City:</label>
              <div class="row container-item-form" style="align-items: baseline;">
                <input
                    type="text"
                    class="form-control input-form-css col-sm"
                    id="city-my-profile"
                    :disabled="disabledInputs.disabledCity"
                    v-model="donorInformation.city"
                >
                <button
                    type="button"
                    v-if="changeDonorInformation.changeCity"
                    class="col-sm-auto btn"
                    @click="disabledInputs.disabledCity = !disabledInputs.disabledCity"
                >
                  <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
                </button>
              </div>
            </div>
            <div class="container-input-form container-input-form-right col-sm-3">
              <label class="label-form-css col-sm-auto" style="padding-left: 0;">State:</label>
              <div class="row container-item-form" style="align-items: baseline;">
                <input
                    type="text"
                    class="form-control input-form-css col-sm"
                    id="state-my-profile"
                    :disabled="disabledInputs.disabledState"
                    v-model="donorInformation.state"
                >
                <button
                    type="button"
                    v-if="changeDonorInformation.changeState"
                    class="col-sm-auto btn"
                    @click="disabledInputs.disabledState = !disabledInputs.disabledState"
                >
                  <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
                </button>
              </div>
            </div>
            <div class="container-input-form container-input-form-right col-sm-4">
              <label class="label-form-css col-sm-auto" style="padding-left: 0;">Zip:</label>
              <div class="row container-item-form" style="align-items: baseline;">
                <input
                    type="text"
                    class="form-control input-form-css col-sm"
                    id="postal-code-profile"
                    :disabled="disabledInputs.disabledZipCode"
                    v-model="donorInformation.zipCode"
                >
                <button
                    type="button"
                    v-if="changeDonorInformation.changeZipCode"
                    class="col-sm-auto btn"
                    @click="disabledInputs.disabledZipCode = !disabledInputs.disabledZipCode"
                >
                  <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="right-col col-md-6">
          <div class="row container-item-form">
            <div
                class="container-input-form container-input-form-left col-sm"
                style="margin-bottom: 0; min-height: 108px;"
            >
                <div class="content-sms-opt">
                  <p>{{ smsOptedOut.banner }}</p>
                </div>
                <div class="container-radio-sms-opt" style="display: flex;">
                  <div class="form-check" style="margin-right: 15px;">
                    <input
                        class="form-check-input"
                        type="radio"
                        name="smsOptedOut"
                        id="exampleRadios1"
                        v-model="smsOptedOut.include"
                        value='false'
                        :checked=smsOptedOut.include
                    >
                    <label class="form-check-label" for="exampleRadios1">
                      Opt In
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                        class="form-check-input"
                        type="radio"
                        name="smsOptedOut"
                        id="exampleRadios2"
                        v-model="smsOptedOut.include"
                        value='true'
                        :checked=smsOptedOut.include

                    >
                    <label class="form-check-label" for="exampleRadios2">
                      Opt Out
                    </label>
                  </div>
                </div>
              </div>
            <div class="container-input-form container-input-form-left col-sm">
            </div>
          </div>
          <div class="row container-item-form">
            <div class="container-input-form container-input-form-left col-sm">
              <div class="row container-item-form" style="text-align: center; width: auto">
                <button
                    type="button"
                    class="button-section btn left-col"
                    v-on:click="downloadDonorCard"
                    style="margin: 15px 0 0 0; "
                >
                  DOWNLOAD DONOR CARD
                  <font-awesome-icon :icon="['fas', 'chevron-right']"/>
                </button>
              </div>
            </div>
            <div class="container-input-form container-input-form-left col-sm">
            </div>
          </div>
        </div>

        <div class="row container-item-form" style="text-align: center; width: auto">
          <button
              type="button"
              class="button-section btn left-col"
              v-on:click="updateInformation"
              style="margin: 0 15px;"
          >
            UPDATE
            <!--            <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
            <font-awesome-icon :icon="['fas', 'chevron-right']"/>
          </button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import {mapState} from "vuex";
import {library} from '@fortawesome/fontawesome-svg-core'
import {faPencilAlt} from '@fortawesome/free-solid-svg-icons'
import moment from 'moment-timezone';
import xlooLib from "../../librarys/xlooLib";

library.add(faPencilAlt)
export default {
  name: "donorProfile",
  data() {
    return {
      donorInformation: {
        firstName   : null,
        lastName    : null,
        dob         : null,
        email       : null,
        mobilePhone : null,
        homePhone   : null,
        street      : null,
        city        : null,
        state       : null,
        zipCode     : null,
        smsOptedOut : null,
      },
      smsOptedOut: {
        banner: '',
        include: 0,
        OptOutState: false,
        OptInState: true,
      },
      changeDonorInformation: {
        changeEmail: false,
        changePassword: false,
        changeFirstName: false,
        changeLastName: false,
        changeDOB: false,
        changeMobilePhone: false,
        changeHomePhone: false,
        changeStreet: false,
        changeCity: false,
        changeState: false,
        changeZipCode: false,
      },
      disabledInputs: {
        disabledEmail: true,
        disabledPassword: true,
        disabledFirstName: true,
        disabledLastName: true,
        disabledDOB: true,
        disabledMobilePhone: true,
        disabledHomePhone: true,
        disabledStreet: true,
        disabledCity: true,
        disabledState: true,
        disabledZipCode: true,
      },
    }
  },
  computed: {
    ...mapState({
      donorInformationState: state => state.donorInformation,
      dhqSettings: state => state.settingsAndCustomize.donorPortalSettings.dhq,
      crmSettings: state => state.settingsAndCustomize.crmSettings,
      messageOptIn: state => state.settingsAndCustomize.siteCustomizationData.profilePage.messageOptIn,
    })
  },
  created() {
    let scc = this
    Object.keys(scc.donorInformation).forEach(function(key) {
      scc.donorInformation[key] = scc.donorInformationState[key]
    }, scc.donorInformation);
    this.donorInformation.mobilePhone = this.donorInformationState.mobilePhone
    this.donorInformation.homePhone = this.donorInformationState.homePhone
  },
  mounted() {
    this.changeDonorInformation.changeEmail = this.crmSettings.editable.email
    this.changeDonorInformation.changeFirstName = this.crmSettings.editable.firstName
    this.changeDonorInformation.changeLastName = this.crmSettings.editable.lastName
    this.changeDonorInformation.changeDOB = this.crmSettings.editable.dob
    this.changeDonorInformation.changeMobilePhone = true
    this.changeDonorInformation.changeHomePhone = this.crmSettings.editable.phoneHome
    this.changeDonorInformation.changeStreet = this.crmSettings.editable.addressStreet
    this.changeDonorInformation.changeCity = this.crmSettings.editable.addressCity
    this.changeDonorInformation.changeState = this.crmSettings.editable.addressState
    this.changeDonorInformation.changeZipCode = this.crmSettings.editable.addressPostalCode

    this.smsOptedOut.banner = this.messageOptIn
    this.smsOptedOut.include = this.donorInformationState.smsOptedOut
  },
  methods: {
    async updateInformation() {
      const checkChangeDonorInformation = this.checkChangeDonorInformation()
      this.donorInformation.smsOptedOut = this.smsOptedOut.include==='true'?1:0
      switch (checkChangeDonorInformation){
        case 'changeAll':
        case 'changeData':
          console.log('changeData')
          await this.updateDonorInformation();
          this.alertMessage(checkChangeDonorInformation);
          break;
        case 'changeEmail':
    //      this.$store.dispatch('donorInformation/SET_changeEmail', this.donorInformation)
          await this.changeEmail()
          this.alertMessage(checkChangeDonorInformation);
          break;
        case 'dontChange':
          this.alertMessage(checkChangeDonorInformation);
          break;
      }
    },
    async downloadDonorCard() {
      this.$root.$emit("showSpinner");
      await this.$store.dispatch('auth/SET_generateDonorCard')
      this.$root.$emit("hideSpinner");
    },
    resetPassword() {
      this.$router.push({name: 'resetPassword'})
    },
    checkChangeDonorInformation(){
      if(
          this.donorInformationState.firstName !== this.donorInformation.firstName ||
          this.donorInformationState.lastName !== this.donorInformation.lastName ||
          this.donorInformationState.dob !== this.donorInformation.dob ||
          this.donorInformationState.mobilePhone !== this.donorInformation.mobilePhone ||
          this.donorInformationState.homePhone !== this.donorInformation.homePhone ||
          this.donorInformationState.street !== this.donorInformation.street ||
          this.donorInformationState.city !== this.donorInformation.city ||
          this.donorInformationState.state !== this.donorInformation.state ||
          this.donorInformationState.zipCode !== this.donorInformation.zipCode ||
          this.donorInformationState.smsOptedOut !== this.smsOptedOut.include
      ){
        if( this.donorInformationState.email !== this.donorInformation.email ){
          return 'changeAll'
        } else {
          return 'changeData'
        }
      } else {
        if ( this.donorInformationState.email !== this.donorInformation.email ){
          return 'changeEmail'
        } else {
          return 'dontChange'
        }
      }
    },
    async changeEmail (){
      const dataEmail = {
        email: this.donorInformation.email,
        idUser: this.donorInformationState.idDonor,
      }

      this.$root.$emit("showSpinner");
      // eslint-disable-next-line no-unused-vars
      const res_sendEmail = await this.$store.dispatch('communication/SET_changeEmail', dataEmail)
      this.$root.$emit("hideSpinner");
    },
    async updateDonorInformation () {
      console.log('updateDonorInformation')
      let dataRequest = {
        action: 'updateProfileData',
        first_name: this.donorInformation.firstName,
        last_name: this.donorInformation.lastName,
        dob: moment(this.donorInformation.dob, 'MM/DD/YYYY').format('YYYY-MM-DD'),
        phone_mobile: xlooLib.phoneCleaner(this.donorInformation.mobilePhone),
        phone_home: xlooLib.phoneCleaner(this.donorInformation.homePhone),
        primary_address_street: this.donorInformation.street,
        primary_address_city: this.donorInformation.city,
        primary_address_state: this.donorInformation.state,
        primary_address_postalcode: this.donorInformation.zipCode,
        sms_opted_out: this.donorInformation.smsOptedOut,
      }

      this.$root.$emit("showSpinner");
      await this.$store.dispatch('pages/SET_setEntry', dataRequest)
      this.$root.$emit("hideSpinner");

      this.$store.commit( 'donorInformation/set_firstName', this.donorInformation.firstName)
      this.$store.commit('donorInformation/set_lastName', this.donorInformation.lastName)
      this.$store.commit('donorInformation/set_phoneMobile', this.donorInformation.mobilePhone)
      this.$store.commit('donorInformation/set_phoneHome', this.donorInformation.homePhone)
      this.$store.commit('donorInformation/set_city', this.donorInformation.city)
      this.$store.commit('donorInformation/set_street', this.donorInformation.street)
      this.$store.commit('donorInformation/set_state', this.donorInformation.state)
      this.$store.commit('donorInformation/set_zipCode', this.donorInformation.zipCode)
    },
    // eslint-disable-next-line no-unused-vars
    alertMessage(flagMessage, alertWarnings=''){
      switch(flagMessage){
        case 'changeAll':
          this.$root.$emit('messageBox',
              {
                timeShow: 2000,
                typeColor: "success",
                textMessage: "Your profile data has been successfully updated. A link to confirm the mailbox change has been sent to your new mailbox.",
              })
          break;
        case 'changeData':
          this.$root.$emit('messageBox',
              {
                timeShow: 2000,
                typeColor: "success",
                textMessage: "Your profile data has been successfully updated.",
              })
          break;
        case 'changeEmail':
          this.$root.$emit('messageBox',
              {
                timeShow: 2000,
                typeColor: "success",
                textMessage: "A link to confirm the mailbox change has been sent to your new mailbox.",
              })
          break;
        case 'dontChange':
          this.$root.$emit('messageBox',
              {
                timeShow: 2000,
                typeColor: "danger",
                textMessage: "You have not changed the data in your profile.",
              })
          break;
      }
    }
  }
}
</script>

<style scoped>
  #out-container-reset-password-button {
    display: flex;
    align-items: flex-end;
  }

  #reset_password_my_profile {
    height: 38px;
  }
</style>
